export const locationFormFields = {
  apartment: "apartment",
  country: "country",
  formatted_address: "formatted_address",
  id: "id",
  lat: "lat",
  lng: "lng",
  name: "name",
  placeId: "placeId",
  street: "street",
  state: "state",
  zipCode: "zipCode",
};
